import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { ExportWorkTimeBaseDialog, ExportWorkTimeBaseDialogProps } from '../ExportWorkTimeBaseDialog/ExportWorkTimeBaseDialog';
export type ExportOwnWorkTimeDialogProps = Omit<ExportWorkTimeBaseDialogProps, 'getUserId'>;
export const ExportOwnWorkTimeDialog: FunctionComponent<ExportOwnWorkTimeDialogProps> = React.memo(props => {
  const $ = _c(9);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const {
    getRequiredCurrentUser
  } = useCurrentUser();
  let t1;
  if ($[4] !== getRequiredCurrentUser) {
    t1 = () => getRequiredCurrentUser().id;
    $[4] = getRequiredCurrentUser;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const getUserId = useEventCallback(t1);
  let t2;
  if ($[6] !== getUserId || $[7] !== remainingProps) {
    t2 = <ExportWorkTimeBaseDialog {...remainingProps} getUserId={getUserId} />;
    $[6] = getUserId;
    $[7] = remainingProps;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});